// Module
var code = "<jm-loader></jm-loader>";
// Exports
module.exports = code;